<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="auth-card-title">{{ lang.title }}</div>
      <form class="auth-form" @submit.prevent="submit()">
        <p class="auth-card-text" v-if="pathMatch === 'email'">
          {{ lang.emailText }}
        </p>
        <p class="auth-card-text" v-else-if="pathMatch === 'google-auth'">
          {{ lang.googleText }}
        </p>
        <p class="auth-card-text" v-else-if="pathMatch === 'sms'">
          {{ lang.phoneText }}
        </p>
        <span v-if="pathMatch !== 'google-auth'" class="countdown"
          >{{ Math.floor(countDown / 60) }}:{{ countDown % 60 }}</span
        >
        <VerifyCodeInput @change="(e) => (otp.code = e)" :num="6" />
        <p class="auth-card-text">{{ lang.emailForText }} {{ otp.username }}</p>
        <LabelInput
          @input="
            (value) => {
              otp.password = value;
            }
          "
          type="password"
          :label="lang.passLabel"
        />
        <LabelInput
          @input="
            (value) => {
              passConfirm = value;
            }
          "
          type="password"
          :label="lang.passConfirmLabel"
        />
        <button
          v-if="countDown > 0"
          :class="{
            disabled:
              !otp.code ||
              !otp.password ||
              otp.password.length < 8 ||
              otp.password != passConfirm,
          }"
          :disabled="
            !otp.code ||
            !otp.password ||
            otp.password.length < 8 ||
            otp.password != passConfirm
          "
          type="submit"
          class="auth-confirm-btn"
        >
          {{ lang.confirmBtn }}
        </button>
        <button
          v-if="countDown === 0"
          @click.prevent="send()"
          class="auth-confirm-btn"
          type="button"
        >
          {{ lang.resend }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangePass",
  data() {
    return {
      lang: this.$languageDict().changePass,
      pathMatch: this.$route.params.type,
      passError: "",
      countDown: 120,
      passConfirm: "",
      num: 6,
      otp: {
        code: "",
        username: this.$cookies.get("username"),
        password: "",
      },
    };
  },

  methods: {
    showPass() {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    checkPass() {
      if (!this.validPass(this.otp.password)) {
        this.passError = this.lang.passError;
      } else {
        this.passError = "";
      }
      if (!this.passError.length) {
        return true;
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        this.timeOut = setTimeout(() => {
          this.countDown--;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$error(this.lang.endTime, "");
      }
    },
    onChange(e) {
      this.otp.code = e;
    },
    validPass(password) {
      let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
      return re.test(password);
    },
    async submit() {
      if (this.checkPass(this.otp.password) && !this.disabled) {
        this.state.loading = true;
        let [res] = await this.$http.post("/users/reset-password", this.otp);
        // this.reset()

        if (res) {
          this.$error(this.lang.successMessage, "", "success");
          await this.$router.push("/Login");
        }
      } else if (this.passError) {
        this.$error(this.passError, "", "error");
      }
    },
    async send() {
      this.state.loading = true;
      // this.reset()
      await this.$axios.post("/users/forget-password", {
        email: this.otp.username,
        authenticationType: "EMAIL",
      });
      this.$error(this.lang.newCodeMessage, "", "success");

      if (this.countDown === 0) {
        if (
          this.state.userInfo.twoStepAuthenticationType !==
          "GOOGLE_AUTHENTICATOR"
        )
          this.countDown = 120;
        this.countDownTimer();
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
  mounted() {
    if (!this.$cookies.get("username")) {
      this.$router.push("/login");
    }
    if (this.pathMatch !== "google-auth") {
      this.countDownTimer();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.countdown {
  color: #fff;
}
</style>
